if (!customElements.get('maerelle-protection')) {
customElements.define('maerelle-protection', class extends HTMLElement {
 connectedCallback() {
  this.button = this.querySelector('button');
  if (!this.onToggle) {
   this.onToggle = () => this.update();
   this.button.addEventListener('click', this.onToggle);
  }
  if (this.choice() !== 'off' && this.button.getAttribute('aria-checked') !== 'true' && !window.maerelleProtectionAutoPending) {
   window.maerelleProtectionAutoPending = this.update(true)
    .finally(() => { window.maerelleProtectionAutoPending = null; });
  }
 }
 choice() {
  try { return sessionStorage.getItem('maerelleProtectionChoice'); }
  catch (_) { return window.maerelleProtectionChoice || null; }
 }
 rememberChoice(value) {
  window.maerelleProtectionChoice = value;
  try {
   if (value === null) sessionStorage.removeItem('maerelleProtectionChoice');
   else sessionStorage.setItem('maerelleProtectionChoice', value);
  } catch (_) {}
 }
 async update(automatic = false) {
  if (this.button.disabled) return;
  const previousChecked = this.button.getAttribute('aria-checked');
  const previousChoice = this.choice();
  const enabled = automatic || previousChecked !== 'true';
  if (!automatic) this.rememberChoice(enabled ? 'on' : 'off');
  const checkoutButtons = Array.from(document.querySelectorAll('button[name="checkout"]'));
  const checkoutStates = checkoutButtons.map(button => button.disabled);
  checkoutButtons.forEach(button => { button.disabled = true; });
  this.button.disabled = true;
  this.button.setAttribute('aria-checked', String(enabled));
  this.setAttribute('aria-busy', 'true');
  const error = this.querySelector('[role="alert"]');
  error.hidden = true;
  const root = window.Shopify.routes.root;
  try {
   const response = await fetch(root + 'cart.js');
   if (!response.ok) throw new Error();
   const cart = await response.json();
   if (enabled && !cart.items.some(item => String(item.variant_id) !== this.dataset.variant)) {
    this.button.setAttribute('aria-checked', 'false');
    return;
   }
   const lines = cart.items.filter(item => String(item.variant_id) === this.dataset.variant);
   const sections = ['cart-drawer', 'cart-icon-bubble'];
   let endpoint, body;
   if (lines.length) {
    const updates = {};
    lines.forEach((line, index) => { updates[line.key] = enabled && index === 0 ? 1 : 0; });
    endpoint = 'cart/update.js';
    body = {updates, sections, sections_url:location.pathname};
   } else if (enabled) {
    endpoint = 'cart/add.js';
    body = {items:[{id:Number(this.dataset.variant),quantity:1}], sections, sections_url:location.pathname};
   } else { this.button.setAttribute('aria-checked','false'); return; }
   const result = await fetch(root + endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
   const data = await result.json();
   if (!result.ok || data.status || data.errors) throw new Error();
   if (!data.sections || !data.sections['cart-drawer'] || !data.sections['cart-icon-bubble']) {
    const refresh = await fetch(root + '?sections=cart-drawer,cart-icon-bubble');
    if (!refresh.ok) throw new Error();
    data.sections = await refresh.json();
   }
   const drawer = document.querySelector('cart-drawer');
   const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
   const summary = drawer.querySelector('.me-cart-summary');
   const nextSummary = doc.querySelector('.me-cart-summary');
   if (!summary || !nextSummary) throw new Error();
   const nextSwitch = nextSummary.querySelector('maerelle-protection button');
   const confirmedChecked = nextSwitch?.getAttribute('aria-checked') || 'false';
   this.button.setAttribute('aria-checked', confirmedChecked);
   summary.querySelectorAll('maerelle-protection button').forEach(button => {
    button.setAttribute('aria-checked', confirmedChecked);
   });
   for (const selector of ['.me-cart-summary__discount', '.me-cart-summary__total']) {
    const current = summary.querySelector(selector);
    const next = nextSummary.querySelector(selector);
    if (current && next) current.replaceWith(next);
    else if (current) current.remove();
    else if (next) summary.append(next);
   }
   for (const selector of ['#CartDrawer-Checkout span', '.me-cart-count', '#CartDrawer-CartItems']) {
    const current = drawer.querySelector(selector);
    const next = doc.querySelector(selector);
    if (current && next) current.innerHTML = next.innerHTML;
   }
   const bubble = document.getElementById('cart-icon-bubble');
   const bubbleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
   const nextBubble = bubbleDoc.querySelector('.shopify-section');
   if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
   const nextDrawer = doc.querySelector('cart-drawer');
   drawer.classList.toggle('is-empty', nextDrawer?.classList.contains('is-empty') || false);

  } catch (_) {
   this.button.setAttribute('aria-checked', previousChecked);
   if (!automatic) this.rememberChoice(previousChoice);
   error.textContent = this.dataset.error;
   error.hidden = false;
  } finally {
   this.button.disabled = false;
   this.removeAttribute('aria-busy');
   checkoutButtons.forEach((button, index) => { if (button.isConnected) button.disabled = checkoutStates[index]; });
  }
 }
});
}
